import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Button, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { treatmentActions } from '../../../../store/MedicalRecord/treatment';
import TreatmentBlock from './TreatmentBlock';
import { DiagnosticForm, TreatmentForm } from '../../../../types/types';
import { RootState } from '../../../../store';

interface Props {
  storedDiagnostic?: DiagnosticForm;
  storedTreatment?: TreatmentForm;
  viewMode: boolean;
}

const Treatment = ({ storedDiagnostic, storedTreatment, viewMode }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let diagnostic = useSelector((state: RootState) => state.diagnostic);
  let treatment = useSelector((state: RootState) => state.treatment);

  if (viewMode && storedDiagnostic != null && storedTreatment != null) {
    diagnostic = storedDiagnostic;
    treatment = storedTreatment;
  }

  const setRecommendationHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    dispatch(treatmentActions.setRecommendation(event.target.value));
  };

  return (
    <Box>
      <h4>Tratamientos</h4>
      {diagnostic.data.map((localData) => (
        <TreatmentBlock
          key={localData.id}
          diagnostic={localData}
          data={treatment}
          viewMode={viewMode}
        />
      ))}
      <div style={{ height: '8px' }} />
      <h4>Recomendaciones</h4>
      <TextField
        id='recommendations'
        value={treatment.recommendation}
        onChange={setRecommendationHandler}
        multiline
        rows={4}
        fullWidth
        disabled={viewMode}
      />
      {!viewMode && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            margin: 1,
            paddingTop: 3
          }}
        >
          <Button color='primary' variant='contained' onClick={() => navigate('/consultas')}>
            Finalizar Consulta
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Treatment;
